import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useObjectStoreTemplatesStore } from "@/stores/objectStoreTemplatesStore";
import { useInstanceRouting } from "./routing";
import CreateForm from "./CreateForm.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateInstance',
    props: {
        templateId: null
    },
    setup(__props) {
        const props = __props;
        const objectStoreTemplatesStore = useObjectStoreTemplatesStore();
        objectStoreTemplatesStore.fetchTemplates();
        const { goToIndex } = useInstanceRouting();
        const template = computed(() => objectStoreTemplatesStore.getLatestTemplate(props.templateId));
        async function onCreated(objectStore) {
            const message = `Created storage location ${objectStore.name}`;
            goToIndex({ message });
        }
        return { __sfc: true, objectStoreTemplatesStore, goToIndex, props, template, onCreated, CreateForm, LoadingSpan };
    }
});
